module.exports = __webpack_public_path__ + "static/images/containers/Journal/images/background-cn.a2bb2154.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/Journal/images/background-cn.jpg
// module id = 3108
// module chunks = 11